import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver-es';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiConfiguration } from 'src/app/api/api-configuration';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor(private config: ApiConfiguration, private http: HttpClient) {}

  // Urls must either be absolute (starting with https://) or relative (but without leading slash)
  download(fileName: string, url: string, params: any = null): Observable<any> {
    const uri = url.indexOf('https://') === 0 ? url : `${this.config.rootUrl}/${url}`;

    return this.http.get(uri, { params, responseType: 'blob' }).pipe(
      tap(blob => {
        saveAs(blob, fileName);
      })
    );
  }
}
